<template>
  <div class="bag-reassurances">
    <div class="bag-reassurances__item">
      <img
        :src="paymentIcon"
        alt=""
        class="bag-reassurances__icon"
        width="20"
        height="20"
      />
      <p>Credit, Debit, PayPal, or Apple Pay</p>
    </div>
    <div class="bag-reassurances__item">
      <img
        :src="returnsIcon"
        alt=""
        class="bag-reassurances__icon"
        width="20"
        height="20"
      />
      <p>{{ returnsMessage }}</p>
    </div>
    <div v-if="bnplMessage" class="bag-reassurances__item">
      <img
        :src="bnplIcon"
        alt=""
        class="bag-reassurances__icon"
        :class="{ 'bag-reassurances__icon--klarna': isKlarna }"
        width="20"
        height="20"
      />
      <p>{{ bnplMessage }}</p>
    </div>
    <p class="bag-reassurances__footnote">
      *Standard exclusions apply. See
      <a href="/pages/terms-conditions">T&Cs</a>
      for further info.
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { paymentMethods } from "@/config.js";
import paymentIcon from "@/assets/icons/bag-payment.svg";
import returnsIcon from "@/assets/icons/bag-returns.svg";
import clearpayIcon from "@/assets/icons/bag-clearpay.svg";
import klarnaIcon from "@/assets/images/payment-methods/klarnaV2.svg";

export default {
  name: "BagReassurances",
  props: {
    price: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentIcon,
      returnsIcon,
      clearpayIcon,
      klarnaIcon,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    returnsMessage() {
      return "14 Day Returns*";
    },
    pdpMessage() {
      return paymentMethods[this.currencyCode]?.pdpMessage || null;
    },
    isKlarna() {
      return this.pdpMessage?.provider?.toLowerCase() === "klarna";
    },
    bnplIcon() {
      return this.isKlarna ? this.klarnaIcon : this.clearpayIcon;
    },
    bnplMessage() {
      if (!this.pdpMessage || !this.price?.amount) {
        return null;
      }

      const { provider, instalments } = this.pdpMessage;
      const installment = this.$filters.toCurrency(
        Number(this.price.amount) / instalments,
        this.price.currencyCode
      );

      return `${instalments} Payments of ${installment} with ${provider}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.bag-reassurances {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.bag-reassurances__item {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 12px;

  p {
    margin: 0;
    @include utility-label(15px);
  }
}

.bag-reassurances__icon {
  width: 20px;
  height: 20px;
  display: block;
  flex: 0 0 20px;
  object-fit: contain;

  &--klarna {
    width: 55px;
    flex: 0 0 55px;
    height: 12px;
  }
}

.bag-reassurances__footnote {
  margin: 4px 0 0;
  text-align: center;
  @include utility-body(13px);
  color: $color-grey-dark;

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}
</style>
